export type AttributeObject = Record<string, unknown>;

const convertDataAttributesToObject = (attributes: DOMStringMap): AttributeObject => {
  const returnedObject = {} as AttributeObject;
  const keys = Object.keys(attributes);

  Object.values(attributes).forEach((value: string | undefined | null, idx) => {
    const key = keys[idx] as string;

    if (typeof value === 'string' && !value.length) {
      returnedObject[key] = value;
    } else {
      try {
        const parsedValue = JSON.parse(`${value}`);
        if (parsedValue) {
          returnedObject[key] = parsedValue;
        }
      } catch (e: unknown) {
        console.warn({ e });
        // returnedObject[key] = `${value}`;
      }
    }
  });

  return returnedObject;
};

export default convertDataAttributesToObject;
